// material-ui
import { useTheme } from "@mui/material/styles";

import ipmsLogo from "assets/images/logo.png";
import ddpsLogo from "assets/images/ddps-transparent-logo.png"
import { Image } from "antd";
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';

 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = ({app}) => {
  const theme = useTheme();

  return (
    <>
      {app == 'ipms' ? <Image src={ipmsLogo} alt="ipms" width={100} preview={false} /> : app =="ddps"? <Image src={ddpsLogo} alt="ddps" width={100} preview={false} />:''}
    </>
  );
};

export default Logo;
